export default __webpack_public_path__ + "static/media/removecart.11f0ac9f.svg";